// extracted by mini-css-extract-plugin
export default {"total":"totalExecutionTime_total__cmgQO","totalResult":"totalExecutionTime_totalResult__JaEHv","passed":"totalExecutionTime_passed__brO3C","error":"totalExecutionTime_error__GW+3f"};